import { type ThemeConfig, theme } from 'antd';

const commonToken: Exclude<ThemeConfig['token'], undefined> = {
  colorPrimary: '#4C6FFF',
  fontSize: 12,
  borderRadius: 4,
};

export const light: ThemeConfig = {
  token: {
    ...commonToken,
    colorText: '#425466',
    colorTextSecondary: '#6F767E',
    colorBorder: '#E1E6EF',
  },
  components: {
    Button: {
      colorBorder: '#E2E8F0',
    },
    Divider: {
      colorSplit: '#F1F5F9',
    },
    Table: {
      headerColor: '#8492A6',
    },
    Switch: {
      colorTextQuaternary: '#CBD5E1',
    },
  },
  algorithm: theme.defaultAlgorithm,
};

export const dark: ThemeConfig = {
  token: {
    ...commonToken,
  },
  algorithm: theme.darkAlgorithm,
};
